import { type ReactNode, useRef, useState } from "react";
import { createPortal } from "react-dom";

type TooltipProps = {
  label: string;
  sublabel?: string;
  children: ReactNode;
};

// Hover tooltip rendered through a portal so it escapes ancestor overflow.
export function Tooltip({ label, sublabel, children }: TooltipProps) {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [pos, setPos] = useState<{ left: number; top: number } | null>(null);

  const show = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ left: r.left + r.width / 2, top: r.top });
  };

  const hide = () => setPos(null);

  return (
    <span
      ref={ref}
      onMouseEnter={show}
      onMouseLeave={hide}
      style={{ position: "relative", display: "inline-flex" }}
    >
      {children}
      {pos &&
        createPortal(
          <div
            className="kpi-tooltip"
            style={{
              left: pos.left,
              top: pos.top - 8,
              transform: "translate(-50%, -100%)",
              position: "fixed",
            }}
          >
            <div style={{ fontWeight: 500 }}>{label}</div>
            {sublabel && <div className="kpi-tooltip-sub mono">{sublabel}</div>}
          </div>,
          document.body
        )}
    </span>
  );
}
